import { EmptyState, PageHeader, TableWrap } from "@/ui";

/** 尚未实现的页面。标题与说明来自导航配置，保证和最终页面一致。 */
export function Placeholder({ title, description }: { title: string; description: string }) {
  return (
    <>
      <PageHeader title={title} description={description} />
      <TableWrap>
        <EmptyState title="尚未实现">这个页面在对应阶段的工作项里实现，见 docs/00-架构设计说明.md 第 15 节。</EmptyState>
      </TableWrap>
    </>
  );
}

/** 未知路径，正式环境里只给开发看的页面也显示它（D179）。 */
export function NotFound() {
  return <Placeholder title="页面不存在" description="检查地址，或从左侧导航进入。" />;
}
